import React from "react";
import { Grid, Typography } from "@mui/material";

const DetailRow = ({ label, value }) => (
  <Grid container item lg={12} spacing={2}>
    <Grid item lg={4}>
      <Typography variant="subtitle1" fontWeight="bold">
        {label}
      </Typography>
    </Grid>
    <Grid item lg={8}>
      <Typography variant="subtitle1">
        <b> : &ensp;</b> {value}
      </Typography>
    </Grid>
  </Grid>
);

export default DetailRow;
